import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('account', [
      'isAdmin',
      'isClient',
      'isConsultant',
      'isStaff'
    ]),

    ...mapGetters('permissions', [
      'hasPermission'
    ])
  }
}
